export interface Auth0EnvConfig {
  domain: string;
  clientId: string;
  audience: string;
}

function requireEnv(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `[auth0] ${String(name)} is not configured. Copy apps/frontend/.env.sample to .env and fill in the dev tenant values.`,
    );
  }
  return value;
}

let cached: Auth0EnvConfig | null = null;

export function getAuth0EnvConfig(): Auth0EnvConfig {
  if (cached) return cached;
  cached = {
    domain: requireEnv('VITE_AUTH0_DOMAIN'),
    clientId: requireEnv('VITE_AUTH0_CLIENT_ID'),
    audience: requireEnv('VITE_AUTH0_AUDIENCE'),
  };
  return cached;
}
